<!-- Generic tooltip container accepts hostElement as input -->
<div
  [tooltipClick]="showOnClick"
  [tooltipContent]="content"
  [tooltipHover]="showOnHover"
  [tooltipPosition]="position"
  [tooltipRole]="tooltipRole"
  class="tooltip-container"
  idpTooltip
>
  <ng-template
    [ngTemplateOutlet]="hostElement ? hostElement : defaultTemplate"
  ></ng-template>
</div>

<!-- Adding this section so that exisiting component does not break-->
<ng-template #defaultTemplate>
  <idp-button
    [elementType]="elementType"
    [label]="buttonLabel"
    [type]="buttonType"
    size="large"
  ></idp-button>
</ng-template>
